import { STATS } from "@/data/site";
import Counter from "@/components/site/Counter";
import { Reveal } from "@/components/site/Reveal";

export default function Stats() {
  return (
    <section
      data-testid="stats-section"
      className="relative bg-[#0B132B] py-20 border-y border-white/10"
    >
      <div className="mx-auto max-w-7xl px-5 md:px-8">
        <div className="grid grid-cols-2 md:grid-cols-4 gap-y-12 gap-x-6">
          {STATS.map((s, i) => (
            <Reveal
              key={s.label}
              delay={i * 0.08}
              className="text-center md:text-left"
            >
              <div className="font-display text-6xl md:text-7xl text-primary leading-none">
                <Counter to={s.value} prefix={s.prefix || ""} suffix={s.suffix || ""} />
              </div>
              <div className="mt-3 font-label text-xs text-[#F8F5F2]/70">
                {s.label}
              </div>
            </Reveal>
          ))}
        </div>
      </div>
    </section>
  );
}
